// B端：appid: 190677959C端：appid: 199784021大数据端：appid: 194779422
export const waterKey = '194779422' //加密key
